import React from 'react';
import { Container, Row } from 'react-bootstrap';

const LifeChangeEventHeader = () => (
  <Row className="mx-0 change-coverage-header">
    <Container>
      <h1 className="coverage-content-header" aria-hidden={true}>
        Change Your Coverage
      </h1>
    </Container>
  </Row>
);
export default LifeChangeEventHeader;
